import {
  QueryRelocationsOrderByColumn,
  RelocationListQueryVariables,
  RelocationType,
  SortOrder,
} from "@/gql/graphql";
import { RelocationListSearchParams } from "@/app/Relocations/Routes/relocationRoute";

export function getRelocationListQueryVariables(
  searchParams: RelocationListSearchParams,
  supplierId: string | null,
): RelocationListQueryVariables {
  const baseParams: RelocationListQueryVariables = {
    first: 20,
    page: 1,
    status: searchParams.relocationStatus,
    search: searchParams.relocationSearch || undefined,
    supplier_id: supplierId ?? undefined,
    type: [RelocationType.Relocation],
    is_linked: false,
  };

  if (searchParams.relocationSearch) {
    return baseParams;
  }

  return {
    ...baseParams,
    // Order by id DESC — unique + monotonic with insert order, so newest first
    // without the duplicate-across-pages risk that created_at had when many
    // rows share a timestamp (e.g. bulk imports).
    orderBy: [
      {
        order: SortOrder.Desc,
        column: QueryRelocationsOrderByColumn.Id,
      },
    ],
  };
}
